
























import { computed, defineComponent, useRoute, ref, useFetch, useContext, useRouter } from '@nuxtjs/composition-api';
import { NavigationGuardNext, Route } from 'vue-router';
import AppLoader from '~/components/partials/App/AppLoader.vue';
import AnswerCard from '~/components/partials/College/AnswerCard.vue';
import CollegeHeader from '~/components/partials/College/CollegeHeader.vue';
import LayoutDefault from '~/components/partials/Layout/LayoutDefault.vue';
import { useCollege } from '~/composables/college/useCollege';
import { useEnotecaApp } from '~/composables/useEnotecaApp';
import { useLayoutProps } from '~/composables/useLayoutProps';
import { useStore } from '~/composables/useStore';
import { CORRECT_NUMBERS, DEVICE_TYPE_FROM_QUIZ } from '~/constants/college';
import { url } from '~/utils';
import { PageError } from '~/utils/error';
import { CollegeLessonQuiz } from '~/types/common';
import { ArticleType, CollegeLessonType } from '~/enums';

export default defineComponent({
  components: {
    AppLoader,
    LayoutDefault,
    AnswerCard,
    CollegeHeader,
  },
  // アプリのwebviewではない、かつ直リンクや画面更新(同じ画面をリロードする)、回答のクエリが不正な場合、質問画面に戻る
  beforeRouteEnter: (to: Route, from: Route, next: NavigationGuardNext) => {
    if (
      to.query.from !== DEVICE_TYPE_FROM_QUIZ.APP &&
      (from.fullPath === '/' || !to.query.number || !CORRECT_NUMBERS.includes(Number(to.query.number)))
    ) {
      next(url('COLLEGE_BASIC_QUIZ', { id: to.params.id, page: to.params.page }));
    } else {
      next();
    }
  },
  setup() {
    const { i18n } = useContext();
    const { isEnotecaAppWebView } = useEnotecaApp();
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const selectedNumber = route.value.query.number.toString();

    const routeParams = route.value.params;
    const quiz = ref<CollegeLessonQuiz>();
    const isLoading = ref(true);
    const lessonTitle = computed(() => store.state.college.detail.lessonInfo.title);
    const { getLessonDetail } = useCollege();

    const { fetchState } = useFetch(async () => {
      try {
        // URL直打ちなどで講座情報をストアに格納できていない場合は、講座詳細を取得する
        if (!store.state.college.detail.lessonInfo.quizIds || !store.state.college.detail.lessonInfo.quizIds.length) {
          await getLessonDetail(Number(routeParams.id), ArticleType.BasicLesson);
        }
        quiz.value = await store.dispatch('college/quiz/fetchLessonQuiz', {
          quizId: Number(store.state.college.detail.lessonInfo.quizIds[Number(route.value.params.page) - 1]),
        });
      } catch {
        throw new PageError(404, {});
      } finally {
        isLoading.value = false;
      }
    });

    useLayoutProps(() => ({
      layout: {
        header: isEnotecaAppWebView.value ? 'never' : 'always',
        headerMenu: 'never',
        helloBar: isEnotecaAppWebView.value ? 'never' : 'needed',
        footer: isEnotecaAppWebView.value ? 'never' : 'always',
        footerMenu: isEnotecaAppWebView.value ? 'never' : 'always',
      },
      head: {
        title: i18n.t('College-03.quiz.title').toString(),
      },
      fetchState,
    }));

    //　アプリのwebviewでなく、不正にクエリを付与して画面遷移してきた場合、質問画面に戻す
    useFetch(async () => {
      if (route.value.query.from === DEVICE_TYPE_FROM_QUIZ.APP && !isEnotecaAppWebView.value) {
        await router.push(url('COLLEGE_BASIC_QUIZ', { id: route.value.params.id, page: route.value.params.page }));
      }
    });

    return {
      CollegeLessonType,
      quiz,
      selectedNumber,
      isEnotecaAppWebView,
      lessonTitle,
      isLoading,
    };
  },
});
